module.exports = __webpack_public_path__ + "static/fipcbeep4-cc5b844c4f168be7111391e85a05c7ae.jpeg";